import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StemLabelDirective } from './stem-label.directive';

@Component({
  selector: 'dojo-stem-label',
  standalone: true,
  template: `
    @if (stemLabelDirective.state.label) {
      <span class="text-md text-primary flex items-center lowercase">({{ stemLabelDirective.state.label }})</span>
    }
  `,
  host: { class: 'flex' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: StemLabelDirective,
      inputs: ['label'],
    },
  ],
})
export class StemLabelComponent {
  constructor(readonly stemLabelDirective: StemLabelDirective) {}
}
